export enum CustomerType {
  Region = "Region",
  Hospital = "Hospital",
  Department = "Department"
}

export enum CustomerDocumentTypes {
  StandingCertificateForTR = "StandingCertificateForTR",
  Other = "Other"
}
